module.exports = __webpack_public_path__ + "c6ef88af70a805acab096750e7a451ce.MP3";